import { Component, ElementRef, Input, OnInit, TemplateRef, ViewChild} from '@angular/core';
import { DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ResponseUnidadEducativaModel, UnidadEducativaModel } from 'src/app/model/Identificacion.model';
import { InstrumentoAtuevaluacionModel, ResponseInstrumentoAtuevaluacionModel } from 'src/app/model/InstrumentoAutoevaluacion.model';
import { JardinModel } from 'src/app/model/Jardin.model';
import { apiService } from 'src/app/service/api.service';
import { InstrumentoAutoevaluacionService } from 'src/app/service/instrumentoAutoevaluacion.service';
import Swal from 'sweetalert2';
import {environment} from '../../../../../environments/environment';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-instrumento-autoevaluacion',
  templateUrl: './instrumento-autoevaluacion.component.html',
  styleUrls: ['./instrumento-autoevaluacion.component.css']
})
export class InstrumentoAutoevaluacionComponent implements OnInit {
  
  @ViewChild('modalInstrumento', { static: true }) modalInstrumento: TemplateRef<any>;
  @ViewChild('modalNiveles', { static: true }) modalNiveles: TemplateRef<any>;
  @Input() simulacion: boolean;
  @ViewChild('inputFile') inputArchivo: ElementRef;
  @ViewChild('divSpinner') divSpinner:ElementRef;
  uniEducativa = new UnidadEducativaModel();
  dataJardin = new JardinModel();
  insAuto = new InstrumentoAtuevaluacionModel();
  archivoCargado = false;
  dataArchivo = new FormData();
  cargando : boolean;
  isModificable : boolean;
  url: string;
  urlSafe: SafeResourceUrl;
  apiEndpoint = environment.apiEndpoint;
  constructor(
    private modal: NgbModal,
    private api: apiService,
    private spinner: NgxSpinnerService,
    private instrumentoAutoevaluacionService: InstrumentoAutoevaluacionService,
    public sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    
    this.cargaInicial();
  }

  cargaInicial(){
    this.cargando = true;
    this.dataJardin = this.api.dataJardin;
    this.unidadEducativa(this.dataJardin);
    this.loadInstrumentoAutoevaluacion(this.dataJardin);
  }

  loadInstrumentoAutoevaluacion(dataJardin: JardinModel) {

    this.spinner.show();
    this.instrumentoAutoevaluacionService.API_GET_obtenerInstrumentoAutoevaluacion(dataJardin.idJardinPeriodo).subscribe((response: ResponseInstrumentoAtuevaluacionModel) => {
      this.insAuto = response.payload;
      if(this.insAuto.estado == 3){
        this.isModificable = true;
      }
      this.cargando = false;
    },
      (err) => {
        this.cargando = false;
        console.log(err);
      });
  }

  unidadEducativa(dataJardin: JardinModel) {
    this.api.API_POST_obtenerUnidadEducatica(dataJardin.id).subscribe((response: ResponseUnidadEducativaModel) => {
      this.uniEducativa = response.payload;
    },
      (err) => {
        console.log(err);
      });
  }

  close(){
    this.modal.dismissAll();
  }

  descargar(){
    this.url = this.apiEndpoint + 'instrumentoAutoevaluacion/descargar/' + this.dataJardin.idJardinPeriodo;
    this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
    this.modal.open(this.modalInstrumento, { size: 'xl' },);
  }

  nivelesDesarrollo(){
    this.modal.open(this.modalNiveles, { size: 'xl' });
  }

  guardar(){
    Swal.fire({
      title: "Loading...",
      html: "Guarando Avance"
    });
    Swal.showLoading();

      this.instrumentoAutoevaluacionService.API_POST_guardarInstrumento(this.dataJardin.idJardinPeriodo, this.insAuto).subscribe((response: ResponseInstrumentoAtuevaluacionModel) => {
        this.insAuto = response.payload;
        Swal.fire({
          title: 'Realizado!',
          text: 'Guardado con éxito',
          icon: 'info',
          confirmButtonText: 'OK'
        });
      },
      (err) => {
        Swal.fire({
          title: 'UPS!',
          text: 'Error al guardar el Instrumento',
          icon: 'error',
          confirmButtonText: 'OK'
        });
        console.log(err);
      });


  }

  finalizar(){

    Swal.fire({
      title: "Loading...",
      html: "Finalizando"
    });
    Swal.showLoading();

    let countPreguntas = 0;
    let countRespuestas = 0;
    let countObservaciones = 0;
    let countObRespuesta = 0;

    this.insAuto.dimensiones.forEach(dimension => {
      dimension.subdimensiones.forEach(subdimension => {
        countPreguntas = countPreguntas + subdimension.instrumentos.length;
        countObservaciones++;

        if(subdimension.observacion.observacion != null && subdimension.observacion.observacion !== ''){
          countObRespuesta++
        }

        subdimension.instrumentos.forEach(instrumento => {
          if (instrumento.categoriaSeleccionada != null){
            countRespuestas = countRespuestas + 1;
          }
        });
      });
    });

    if (countPreguntas == countRespuestas && countObservaciones ==  countObRespuesta) {

      this.instrumentoAutoevaluacionService.API_POST_finalizarInstrumento(this.dataJardin.idJardinPeriodo, this.insAuto).subscribe((response: ResponseInstrumentoAtuevaluacionModel) => {
            this.insAuto = response.payload;

            Swal.fire({
              title: 'Realizado!',
              text: 'Finalizado con éxito',
              icon: 'info',
              confirmButtonText: 'OK'
            })

          },
          (err) => {
            Swal.fire({
              title: 'UPS!',
              text: 'Error al finalzar el Instrumento',
              icon: 'error',
              confirmButtonText: 'OK'
            });
            console.log(err);
          });
    }else{
      Swal.fire({
        title: 'Faltan Respuestas',
        text: 'Debe responder a todas las preguntas para finalzar el Instrumento',
        icon: 'error',
        confirmButtonText: 'OK'
      });
    }




  }

  cambioArchivo(event){
    this.dataArchivo = new FormData();
    const extension = event.target.files[0].name.substring(event.target.files[0].name.lastIndexOf(".") + 1, event.target.files[0].name.length)
    const extensionesValidas = ["pdf"];
    const existeExtension = extensionesValidas.map(x=> x).indexOf(extension.toLowerCase());
    this.archivoCargado = false;
    if(existeExtension == -1){
      Swal.fire({
        title: 'Error!',
        text: 'Ingrese un archivo valido',
        icon: 'error',
        confirmButtonText: 'OK'
      });
    }else{
      this.dataArchivo.append('file', event.target.files[0]);
      this.archivoCargado = true;
    }
  }

  subirArchivo(event){
    if(this.archivoCargado){
      this.spinner.show();
      this.instrumentoAutoevaluacionService.API_POST_guardarArchivoIntrumento(this.dataJardin.idJardinPeriodo, this.dataArchivo).subscribe((response: ResponseInstrumentoAtuevaluacionModel) => {
        this.insAuto = response.payload;
        this.spinner.hide();
      },
      (err) => {
        Swal.fire({
          title: 'UPS!',
          text: 'El archivo supera el peso máximo (3 mb)',
          icon: 'error',
          confirmButtonText: 'OK'
        });
        console.log(err);
      });
    } else {
      Swal.fire({
        title: 'Error!',
        text: 'Ingrese un archivo valido',
        icon: 'error',
        confirmButtonText: 'OK'
      });
    }
  }

  cancelarArchivo(){
    this.inputArchivo.nativeElement.value = null;
  }
}
